import { render, staticRenderFns } from "./ArticleCardLoading.vue?vue&type=template&id=7fad840e&scoped=true&"
import script from "./ArticleCardLoading.vue?vue&type=script&lang=js&"
export * from "./ArticleCardLoading.vue?vue&type=script&lang=js&"
import style0 from "./ArticleCardLoading.vue?vue&type=style&index=0&id=7fad840e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fad840e",
  null
  
)

export default component.exports